/**
 * Main variables
 */
let mainSlider, navSlider;
const template = {
  index: document.querySelector('.template-index'),
  product: document.querySelector('.template-product'),
  page: document.querySelector('.template-page'),
};

/**
 * Apps class
 */
class Apps {
  constructor() {
    //classes
    this.classes = {
      navScrollBottom: 'menu__nav--scrollBottom',
      navScrollTop: 'menu__nav--scrollTop',
      preventScrolling: 'prevent-scrolling',
      slideshow: {
        class: 'slideshow-home',
        active: 'swiper-slide-active',
        zoom: 'index__image--zoom',
        section: 'menu__nav--section--slideshow',
        captionOpen: 'index__caption--open',
        isVisible: 'slideshow-isVisible',
      },
      siteNav: {
        items: 'SiteNav li',
        activeDropdown: 'site-nav--active-dropdown',
        hasDropdown: 'site-nav--has-dropdown',
        isOpen: 'isOpen',
        isFixed: 'isFixed',
        isBlended: 'isBlended',
        bodyDrawerOpen: 'js-drawer-open',
        childItem: 'site-nav__childlist-item',
        childItemSelected: 'site-nav__childlist-item--selected',
      },
      mobileNav: {
        dropdownOpen: 'mobile-nav__dropdown--open',
        isSticky: 'isSticky',
        expand: 'mobile-nav__expand--show',
        easeIn: 'mobile-nav__link--in',
      },
      menu: {
        open: 'menu__nav--open',
        btnCrossed: 'menu__nav--button--crossed',
      },
    };

    //main variables
    this.container = document.querySelector('.page-container');
    this.landingBtn = document.querySelector('.start-scroll');
    this.animation = document.querySelector('#animated-code');
    this.slideshowContainer = document.querySelector('.' + this.classes.slideshow.class);

    //desktop variables
    this.headerNav = document.querySelector('[data-section-id="header"]');

    //nav variables
    this.navWrapper = document.querySelector('.menu__nav--wrapper');
    this.navButton = document.querySelector('.menu__nav--button');
    this.navLeftEl = document.querySelector('.menu__nav--left');
    this.navRightEl = document.querySelector('.menu__nav--right');
    this.navMidEl = document.querySelector('.menu__nav--mid');
    this.navMenuToggle = document.querySelector('.menu__nav--right .menu__nav--hamburger--toggle');

    //menu variables
    this.mobileMenu = document.querySelector('.mobile-nav-wrapper');
    this.mobileMenuLinks = document.querySelectorAll('.mobile-nav__link:not(.mobile-nav__sublist-link)');

    //swiper elements
    this.imageContainer = document.querySelector('.index__image--container');
    this.captionWrapper = document.querySelector('.index__text--wrapper');
    this.swiperSlides = document.querySelectorAll('.index__image--container .swiper-slide');
    this.navigation = document.querySelectorAll('.swiper-button-custom-next, .swiper-button-custom-prev');

    //init
    if (template.index) this.landing();
    this.manageButton();
    this.manageMenuToggle();
    this.desktopNavManager();
    this.mobileMenuManager();
    this.scrollManager();
    if (isDesktop && template.index) this.slideShowManager();

    //global variables
    this.touchMoveIteration = 0;
    this.touchMoveArray = [];
    this.boundListener = this.scrollOveride.bind(this);
    this.canScroll = true;
  }

  /**
   * all landing page scripts
   */
  landing() {
    this.landingBtn.addEventListener('click', () => {
      this.startScroll();
    });
  }

  /**
   * Button has multiple functions
   * - toggle caption
   * - scroll top
   * - scroll down
   * - toggle menu
   */
  manageButton() {
    this.navButton.addEventListener('click', (e) => {
      let menuSection = e.target.parentElement.parentElement;
      if (this.captionWrapper && this.captionWrapper.classList.contains(this.classes.slideshow.captionOpen)) {
        this.closeCaption();
      } else if (this.navWrapper.classList.contains(this.classes.menu.open)) {
        this.closeMenu();
      } else if (!template.index) {
        history.back();
      } else if (
        menuSection.classList.contains(this.classes.navScrollBottom) ||
        menuSection.classList.contains(this.classes.navScrollTop)
      ) {
        polyScroll(document.querySelector('.' + this.classes.slideshow.class), 500);
      } else if (template.index) {
        polyScroll(document.querySelector('.' + this.classes.slideshow.class), 500);
        this.openCaption();
      }
    });
  }

  /**
   * Mobile hamburger menu toggle
   */
  manageMenuToggle() {
    this.navMenuToggle.addEventListener('click', () => {
      if (this.captionWrapper && this.captionWrapper.classList.contains(this.classes.slideshow.captionOpen)) {
        this.closeCaption();
        this.openMenu();
      } else if (this.navWrapper.classList.contains(this.classes.menu.open)) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });
  }

  /**
   * open / hide desktop menu
   * toggle sub-menus
   */
  desktopNavManager() {
    //show menu on mouse enter & toggle on menu change
    document.querySelectorAll(`#${this.classes.siteNav.items}.${this.classes.siteNav.hasDropdown}`).forEach((el) => {
      el.addEventListener('click', (event) => {
        let activeNav = document.querySelector(
          `#${this.classes.siteNav.items}.${this.classes.siteNav.hasDropdown}.${this.classes.siteNav.activeDropdown}`
        );
        if (activeNav) {
          activeNav.classList.remove(this.classes.siteNav.activeDropdown);
        }
        this.headerNav.classList.add(this.classes.siteNav.isOpen);
        el.classList.add(this.classes.siteNav.activeDropdown);
        document.body.classList.add(this.classes.siteNav.bodyDrawerOpen);
        this.toggleSubNav(event.currentTarget);
      });
    });
    //hide menu on mouse leave
    document.querySelectorAll('header, html').forEach((el) => {
      el.addEventListener('mouseleave', (event) => {
        if (
          document.querySelector(`.${this.classes.siteNav.activeDropdown}`) &&
          (event.relatedTarget == null || !event.relatedTarget.classList.contains(this.classes.siteNav.hasDropdown))
        ) {
          this.headerNav.classList.remove(this.classes.siteNav.isOpen);
          document
            .querySelector(`.${this.classes.siteNav.activeDropdown}`)
            .classList.remove(this.classes.siteNav.activeDropdown);
          document.body.classList.remove(this.classes.siteNav.bodyDrawerOpen);
        }
      });
    });
  }

  /**
   * desktop sub-menus toggling
   * @param {object} event
   */
  toggleSubNav(event) {
    //show submenu on mouseenter
    event.querySelectorAll(`.${this.classes.siteNav.childItem}`).forEach((el) => {
      el.addEventListener('click', (e) => {
        event.querySelectorAll(`.${this.classes.siteNav.childItem}`).forEach((elem) => {
          elem.classList.remove(this.classes.siteNav.childItemSelected);
        });
        e.currentTarget.classList.add(this.classes.siteNav.childItemSelected);
      });
    });
  }

  /**
   * mobile menu navigation
   */
  mobileMenuManager() {
    //observe sticky menu
    this.menuObserver = new IntersectionObserver(this.triggerMenuObserver.bind(this), {
      root: this.mobileMenu,
      rootMargin: '0px 0px -100%',
    });
    //animate menu based on menu state
    this.mobileMenuLinks.forEach((mobileMenuLink) => {
      mobileMenuLink.addEventListener('click', (stickyMenu) => {
        stickyMenu.currentTarget.classList.toggle(this.classes.mobileNav.dropdownOpen);
        this.animateMenu(
          stickyMenu.currentTarget,
          stickyMenu.currentTarget.classList.contains(this.classes.mobileNav.dropdownOpen)
        );
        for (let menu of this.mobileMenuLinks) {
          if (menu.classList.contains(this.classes.mobileNav.dropdownOpen) && menu != stickyMenu.currentTarget) {
            menu.classList.remove(this.classes.mobileNav.dropdownOpen);
            this.animateMenu(menu, false);
          }
        }
      });
    });
  }

  /**
   * smooth scroll to slideshow with interaction observer
   */
  scrollManager() {
    //disable scroll restauration
    history.scrollRestoration = 'manual';
    //observe scroll position to slideShow
    this.slideshowObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target.classList.contains(this.classes.slideshow.class)) {
            if (entry.isIntersecting) {
              console.log('slideshow getting in focus');
              //slideshow section intersecting
              this.headerNav.classList.remove(this.classes.siteNav.isFixed);
              this.navWrapper.parentElement.classList.remove(this.classes.navScrollBottom);
              this.headerNav.classList.add(this.classes.siteNav.isBlended);
              this.navWrapper.parentElement.classList.remove(this.classes.navScrollTop);
              this.navWrapper.classList.add(this.classes.slideshow.section);
              this.slideshowContainer.classList.add(this.classes.slideshow.isVisible);
              this.startScroll();
              this.animation.classList.remove('animated-code');
            } else if (!entry.intersectionRatio == 0) {
              console.log('slideshow out of focus');
              this.headerNav.classList.add(this.classes.siteNav.isFixed);
              this.headerNav.classList.remove(this.classes.siteNav.isBlended);
              this.navWrapper.classList.remove(this.classes.slideshow.section);
              this.slideshowContainer.classList.remove(this.classes.slideshow.isVisible);
              if (this.captionWrapper.classList.contains(this.classes.slideshow.captionOpen)) {
                this.closeCaption();
              }
              if (entry.boundingClientRect.y < 0) {
                this.navWrapper.parentElement.classList.add(this.classes.navScrollTop);
                //lazyload video
                let lazyVideo = document.querySelector('video.lazy');
                if (lazyVideo) {
                  lazyVideo.firstElementChild.src = lazyVideo.firstElementChild.dataset.src;
                  lazyVideo.load();
                  lazyVideo.classList.remove('lazy');
                }
              }
              this.animation.classList.add('animated-code');
            }
          } else if (entry.target.classList.contains('landing-top-sentinel')) {
            if (entry.isIntersecting) {
              console.log('top of window');
              this.headerNav.classList.remove(this.classes.siteNav.isFixed);
              if (template.index) {
                this.disableScroll();
                this.navWrapper.parentElement.classList.add(this.classes.navScrollBottom);
              }
            } else {
              console.log('scrolling down from top');
              template.index && this.startScroll();
              this.headerNav.classList.add(this.classes.siteNav.isFixed);
            }
          }
        });
      },
      { threshold: 0.8 }
    );
    template.index && this.slideshowObserver.observe(document.querySelector('.' + this.classes.slideshow.class));
    this.slideshowObserver.observe(document.querySelector('.landing-top-sentinel'));
  }

  /**
   * enable wheel/touch event
   */
  enableScroll() {
    this.touchMoveIteration = 0;
    this.touchMoveArray = [];
    window.removeEventListener('wheel', this.boundListener, { passive: false });
    window.removeEventListener('touchmove', this.boundListener, { passive: false });
    console.log('scroll enabled');
  }

  /**
   * disable wheel/touch event and overide it
   */
  disableScroll() {
    window.addEventListener('wheel', this.boundListener, { passive: false });
    window.addEventListener('touchmove', this.boundListener, { passive: false });
    console.log('scroll disabled');
  }

  /**
   * overide default scroll behaviour & slide down to slideshow
   */
  scrollOveride(e) {
    console.log('scroll being overriden', e);
    e.preventDefault();
    if (e.type == 'touchmove') {
      this.touchMoveIteration += 1;
      this.touchMoveArray.push(e);
      //console.log('touchMoveIteration, touchMoveArray :>> ', this.touchMoveIteration, this.touchMoveArray);
      if (this.touchMoveIteration == 2) {
        let startPos = this.touchMoveArray[0].changedTouches[0].clientY;
        let endPos = this.touchMoveArray[1].changedTouches[0].clientY;
        console.log('startPos, endPos :>> ', startPos, endPos);
        if (startPos > endPos) {
          this.startScroll(e);
        } else {
          this.touchMoveIteration = 0;
          this.touchMoveArray = [];
        }
      }
    } else if (e.deltaY > 0) {
      this.startScroll(e);
    }
  }

  /**
   * start scroll and toogle classes
   */
  startScroll(e) {
    e && e.preventDefault();
    if (this.canScroll) {
      this.canScroll = false;
      this.container.classList.add(this.classes.preventScrolling);
      document.documentElement.classList.add(this.classes.preventScrolling);
      polyScroll(document.querySelector('.' + this.classes.slideshow.class), 500);
      setTimeout(() => {
        this.container.classList.remove(this.classes.preventScrolling);
        document.documentElement.classList.remove(this.classes.preventScrolling);
        this.enableScroll();
        this.canScroll = true;
      }, 775);
    }
  }

  /**
   * open slideshox caption
   */
  openCaption() {
    navSlider.allowTouchMove = false;
    for (const slide of this.swiperSlides) {
      slide.classList.add(this.classes.slideshow.zoom);
    }
    //set elements to open caption
    this.captionWrapper.classList.add(this.classes.slideshow.captionOpen);
    this.navButton.classList.add(this.classes.menu.btnCrossed);
    this.container.classList.add(this.classes.preventScrolling);
    document.documentElement.classList.add(this.classes.preventScrolling);
  }

  /**
   * close slideshox caption
   */
  closeCaption() {
    navSlider.allowTouchMove = true;
    for (const slide of this.swiperSlides) {
      slide.classList.remove(this.classes.slideshow.zoom);
    }
    //reset elements to default
    this.captionWrapper.querySelector(`.${this.classes.slideshow.active}`).scrollTop = 0;
    this.captionWrapper.classList.remove(this.classes.slideshow.captionOpen);
    this.navButton.classList.remove(this.classes.menu.btnCrossed);
    this.container.classList.remove(this.classes.preventScrolling);
    document.documentElement.classList.remove(this.classes.preventScrolling);
    //patch safari overflow repaint glith
    if (window.safari !== undefined) {
      this.captionWrapper.style.display = 'table';
      this.captionWrapper.offsetHeight;
      this.captionWrapper.style.display = '';
    }
  }

  /**
   * open mobile menu
   */
  openMenu() {
    //set elements to open menu
    this.navWrapper.classList.add(this.classes.menu.open);
    this.navButton.classList.add(this.classes.menu.btnCrossed);
    //blured zoom
    setTimeout(() => {
      this.imageContainer.querySelector(`.${this.classes.slideshow.active}`).classList.add(this.classes.slideshow.zoom);
      document.documentElement.classList.add(this.classes.preventScrolling);
    }, 400);
    //reset native scroll behaviour
    this.enableScroll();
  }

  /**
   * close mobile menu
   */
  closeMenu() {
    //reset elements to default
    this.navWrapper.classList.remove(this.classes.menu.open);
    this.navButton.classList.remove(this.classes.menu.btnCrossed);
    //delay translateY + remove blured zoom
    setTimeout(() => {
      this.imageContainer
        .querySelector(`.${this.classes.slideshow.active}`)
        .classList.remove(this.classes.slideshow.zoom);
      document.documentElement.classList.remove(this.classes.preventScrolling);
    }, 400);
  }

  /**
   * sticky mobile menu
   */
  triggerMenuObserver(entries) {
    let intersectingArray = [];
    entries.forEach((entry) => {
      intersectingArray.push(entry.isIntersecting);
      //check if sticky menu
      if (intersectingArray.includes(true)) {
        entry.target.parentElement.parentElement.parentElement.classList.add(this.classes.mobileNav.isSticky);
      } else {
        entry.target.parentElement.parentElement.parentElement.classList.remove(this.classes.mobileNav.isSticky);
      }
    });
  }

  /**
   * animate mobile menu accordeons and ease-in sub-menus
   * @param {object} stickyMenu
   * @param {boolean} observing
   */
  animateMenu(stickyMenu, observing) {
    let mobileMenuLink = stickyMenu.nextElementSibling;
    if (observing) {
      //open sticky menu
      mobileMenuLink.style.height = 'auto';
      this.mobileMenu.scrollTop = stickyMenu.offsetTop + 1;
      //slide-in sub-menu
      setTimeout(() => {
        stickyMenu.nextElementSibling
          .querySelectorAll('.mobile-nav__dropdown[data-level="3"] .mobile-nav__item')
          .forEach((link, index) => {
            link.classList.add(this.classes.mobileNav.easeIn);
            link.style.transitionDelay = 0.1 * index + 's';
          });
      }, 200);
      //observe sticky menu
      this.menuObserver.observe(stickyMenu.parentElement);
    } else {
      //close menu
      mobileMenuLink.style.height = '0px';
      this.mobileMenu.parentElement.classList.remove(this.classes.mobileNav.isSticky);
      //slide-out sub-menu
      setTimeout(() => {
        stickyMenu.nextElementSibling
          .querySelectorAll('.mobile-nav__dropdown[data-level="3"] .mobile-nav__item')
          .forEach((link, index) => {
            link.classList.remove(this.classes.mobileNav.easeIn);
          });
      }, 200);
      //unobserve sticky menu
      this.menuObserver.unobserve(stickyMenu.parentElement);
    }
    //hide expand button if no menu dropdown
    if (document.querySelector(`.${this.classes.mobileNav.dropdownOpen}`)) {
      this.mobileMenu.classList.add(this.classes.mobileNav.expand);
    } else {
      this.mobileMenu.classList.remove(this.classes.mobileNav.expand);
    }
  }

  /**
   * Slideshow manager
   */
  slideShowManager() {
    // reset caption state when nav is used
    for (let nav of this.navigation) {
      nav.addEventListener('click', () => {
        if (isDesktop && this.captionWrapper.classList.contains(this.classes.slideshow.captionOpen)) {
          this.closeCaption();
        }
      });
    }
  }
}

/**
 * Swiper slider
 */
function swiperSlider() {
  //Slider params
  let mainSliderSelector = '.index__image--wrapper';
  let navSliderSelector = '.index__text--wrapper';
  let demoBtns = document.querySelectorAll('.swiper-button-demo');

  //Main Slider Options
  let mainSliderOptions = {
    loop: true,
    speed: 750,
    touchAngle: 30,
    touchReleaseOnEdges: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    hashNavigation: {
      replaceState: true,
      watchState: true,
    },
    breakpoints: {
      1050: {
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
      },
      1875: {
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
      },
    },
  };

  //Navigation slider params
  let navSliderOptions = {
    loop: true,
    speed: 750,
    touchAngle: 30,
    loopPreventsSlide: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    hashNavigation: {
      replaceState: true,
      watchState: true,
    },
    breakpoints: {
      1050: {
        navigation: {
          nextEl: '.swiper-button-custom-next',
          prevEl: '.swiper-button-custom-prev',
        },
      },
    },
    on: {
      realIndexChange: function (e) {
        let activeSlide = document.querySelectorAll('.index__text--slide')[e.activeIndex];
        for (let btn of demoBtns) {
          if (activeSlide.dataset.url != '') {
            btn.classList.remove('swiper-button-demo--hidden');
            btn.href = activeSlide.dataset.url;
          } else {
            btn.classList.add('swiper-button-demo--hidden');
          }
        }
      },
    },
  };

  //Slider init & controls
  mainSlider = new Swiper(mainSliderSelector, mainSliderOptions);
  navSlider = new Swiper(navSliderSelector, navSliderOptions);
  mainSlider.controller.control = navSlider;
  navSlider.controller.control = mainSlider;
}

/**
 * Smooth scroll polyfill
 */
function polyScroll(element, duration, offset = 0) {
  let desktop = window.matchMedia('(min-width:1020px)').matches;
  let root = desktop ? window : document.querySelector('.page-container');
  let start = null;
  let pos = 0;
  const target = element && element ? element.getBoundingClientRect().top - offset : 0;
  const firstPos = desktop ? window.pageYOffset || document.documentElement.scrollTop : root.scrollTop;

  (function () {
    var browser = ['moz', 'webkit', 'o'];
    for (let x = 0, length = browser.length; x < length && !window.requestAnimationFrame; x++) {
      window.requestAnimationFrame = window[browser[x] + 'RequestAnimationFrame'];
      window.cancelAnimationFrame =
        window[browser[x] + 'CancelAnimationFrame'] || window[browser[x] + 'CancelRequestAnimationFrame'];
    }
  })();

  function showAnimation(timestamp) {
    //console.log(timestamp)
    if (!start) {
      start = timestamp || new Date().getTime();
    }
    let elapsed = timestamp - start;
    let progress = elapsed / duration;
    //ease in function
    const outQuad = function (n) {
      return n * (2 - n);
    };
    let easeInPercentage = +outQuad(progress).toFixed(2);
    pos = target === 0 ? firstPos - firstPos * easeInPercentage : firstPos + target * easeInPercentage;
    root.scrollTo(0, pos);
    //console.warn(pos, target, firstPos, progress);
    if ((target >= 0 && pos >= firstPos + target) || (target === 0 && pos <= 0) || progress >= 1) {
      cancelAnimationFrame(start);
      pos = 0;
    } else {
      window.requestAnimationFrame(showAnimation);
    }
  }
  window.requestAnimationFrame(showAnimation);
}

/**
 * Calculate scroll bar width
 */
function getSBW() {
  //scroll bar width
  let desktop = window.matchMedia('(min-width:1020px)').matches;
  document.documentElement.style.setProperty(
    '--sbw',
    `${
      window.innerWidth - (desktop ? document.body.clientWidth : document.querySelector('.page-container').clientWidth)
    }px`
  );
}

/**
 * Submit language selectors
 */
function switchLanguage() {
  let select = document.querySelector('#localization_form select');
  document.querySelector('.language__picker--buttons').addEventListener('click', function (e) {
    console.log(e.target.dataset.language);
    select.value = e.target.dataset.language;
    select.form.submit();
  });
}

/**
 * Scroll down to slideshow if hash url
 */
function hashScroll() {
  if (window.location.hash) {
    window.addEventListener('load', () => {
      menu.startScroll();
    });
  }
}

/**
 * Check medium type desktop/mobile
 */
function isDesktop() {
  return window.matchMedia('(min-width:1020px)').matches;
}

/**
 * Medium swaper
 */
function mediumSwaper() {
  let swapTrigger = document.querySelector('#medium-swap');
  let sections = document.querySelector('.sections__wrapper');
  let iframe = document.querySelector('#mobile-frame');
  let iframeLoaded = false;
  let scrollOffset;
  swapTrigger.addEventListener('click', function () {
    //toggle class
    sections.classList.toggle('mobile-view__wrapper');
    //inject iframe in DOM if not yet loaded
    if (iframe.src != window.location.href) {
      iframe.addEventListener('load', function () {
        iframe.contentDocument.body.classList.add('mobile-view');
        iframe.dataset.loading = 'loaded';
        iframeLoaded = true;
      });
      iframe.src = window.location.href;
    }
    //toggle iframe action once loaded
    if (sections.classList.contains('mobile-view__wrapper')) {
      //scale to fit screen
      let scaleDiff = 1 - (850 - Math.max(window.innerHeight * 0.75, 650)) / 850;
      document.documentElement.style.setProperty('--mobile-view-scale', scaleDiff);
      scrollOffset = Math.max((80 + window.innerHeight - 850 * scaleDiff) / 2, 100);
      //show iframe
      iframe.style.maxHeight = 'none';
      iframeLoaded && (iframe.dataset.loading = 'loaded');
      polyScroll(iframe, 500, scrollOffset);
    } else {
      iframe.dataset.loading = '';
      iframe.style.maxHeight = '0';
    }
  });
}

/**
 * load Appzi feedback widget
 */
function loadAppzi() {
  if (typeof appzi !== 'undefined') {
    appzi.openWidget('2ee8d2ec-9b53-4304-964d-ff93017798e0');
  } else {
    let appziScript = document.createElement('script');
    appziScript.onload = function () {
      const isAppziReady = setInterval(function () {
        if (typeof appzi !== 'undefined') {
          appzi.openWidget('2ee8d2ec-9b53-4304-964d-ff93017798e0');
          clearInterval(isAppziReady);
        }
      }, 100);
    };
    appziScript.src = 'https://w.appzi.io/w.js?token=xX2IN';
    document.head.appendChild(appziScript);
  }
}

/**
 * instantiate class and scripts
 */
const menu = new Apps(); // init menu
getSBW(); // calcualte scroll bar width
if (template.index) {
  switchLanguage(); // switch language selector form
  swiperSlider(); // init index slideshow
  hashScroll(); // init scroll to slideshow if hash url
} else if (template.page) {
  mediumSwaper(); // swap between mobile/desktop view
}

/**
 * Shopify Editor
 */
document.addEventListener('shopify:section:load', function () {
  swiperSlider();
  const menu = new Apps();
});
